import { render, staticRenderFns } from "./OrderEmpty.vue?vue&type=template&id=1aa99c27&scoped=true&"
import script from "./OrderEmpty.vue?vue&type=script&lang=ts&setup=true&"
export * from "./OrderEmpty.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./OrderEmpty.vue?vue&type=style&index=0&id=1aa99c27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa99c27",
  null
  
)

export default component.exports